type Props = {
	type: "start" | "end";
	onPointerDown: (e: PointerEvent) => void;
	/** Solid ref callback; parent stores the element for focus / keyboard routing. */
	ref?: (el: HTMLButtonElement | undefined) => void;
};

const CHEVRON_D: Record<Props["type"], string> = {
	start: "M2.5 3L4.5 6L2.5 9",
	end: "M5.5 3L3.5 6L5.5 9",
};

export const Handle = (props: Props) => {
	const label = () => (props.type === "start" ? "Trim start" : "Trim end");
	const clsList = () => ({
		"video-scrubber__handle": true,
		"video-scrubber__handle--start": props.type === "start",
		"video-scrubber__handle--end": props.type === "end",
	});
	return (
		<button
			type="button"
			classList={clsList()}
			aria-label={label()}
			tabIndex={props.type === "start" ? 0 : -1}
			ref={(el) => {
				props.ref?.(el ?? undefined);
			}}
			onPointerDown={props.onPointerDown}
		>
			<svg
				class="video-scrubber__handle-chevron"
				viewBox="0 0 8 12"
				aria-hidden="true"
			>
				<path
					d={CHEVRON_D[props.type]}
					fill="none"
					stroke="currentColor"
					stroke-width="1.6"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</button>
	);
};
